export const mergeTeamMemberUserIds = (
    existingUserIds: readonly number[],
    userIdsToAdd: readonly number[],
): number[] => {
    const merged = new Set(existingUserIds);
    userIdsToAdd.forEach((userId) => merged.add(userId));
    return [...merged];
};
